export default {
  "mainVegetable": "povrce",
  "mainVegetable/01": "povrce/patlidzani",
  "mainVegetable/02": "povrce/sparoge",
  "mainVegetable/03": "povrce/avokado",
  "mainVegetable/04": "povrce/cikla",
  "mainVegetable/05": "povrce/brokula",
  "mainVegetable/06": "povrce/mrkva",
  "mainVegetable/07": "povrce/celer",
  "mainVegetable/08": "povrce/gljive",
  "mainVegetable/09": "povrce/kupus",
  "mainVegetable/10": "povrce/kupus-kelj",
  "mainVegetable/11": "povrce/kineski-kupus",
  "mainVegetable/12": "povrce/karfiol",
  "mainVegetable/13": "povrce/kupus-salata",
  "mainVegetable/14": "povrce/krastavac",
  "mainVegetable/15": "povrce/tikvica",
  "mainVegetable/16": "povrce/endivija",
  "mainVegetable/17": "povrce/spanac",
  "mainVegetable/18": "povrce/grah-bobice",
  "mainVegetable/19": "povrce/flazoleti",
  "mainVegetable/20": "povrce/ravni-grah",
  "mainVegetable/21": "povrce/suhi-grasak",
  "mainVegetable/22": "povrce/zelena-boranija",
  "mainVegetable/23": "povrce/lece",
  "mainVegetable/24": "povrce/makedonska-salata",
  "mainVegetable/25": "povrce/vise",
  "mainVegetable/26": "povrce/mjesavina-zelenih-salata",
  "mainVegetable/27": "povrce/repa",
  "mainVegetable/28": "povrce/luk",
  "mainVegetable/29": "povrce/grasak",
  "mainVegetable/30": "povrce/paprike",
  "mainVegetable/31": "povrce/krompir-i-krompir",
  "mainVegetable/32": "povrce/klice-soje",
  "mainVegetable/33": "povrce/rotkvice",
  "mainVegetable/34": "povrce/salata-od-hrastovog-lista",
  "mainVegetable/35": "povrce/frisee-salata",
  "mainVegetable/36": "povrce/iceberg-salata",
  "mainVegetable/37": "povrce/pijemont-salata",
  "mainVegetable/38": "povrce/salata-od-rize",
  "mainVegetable/39": "povrce/rimska-salata",
  "mainVegetable/40": "povrce/mladi-izdanci",
  "mainVegetable/41": "povrce/zelena-salata",
  "mainVegetable/42": "povrce/matovilac",
  "mainVegetable/43": "povrce/rukola",
  "mainVegetable/44": "povrce/sparoge",
  "mainVegetable/45": "povrce/tabule",
  "mainVegetable/46": "povrce/paradajz",
  "mainVegetable/47": "povrce/putarana-mahunarka",
  "mainVegetable/48": "povrce/leblebija",
  "mainVegetable/49": "povrce/praziluk",
  "mainVegetable/50": "povrce/bundeva",
  "mainVegetable/51": "povrce/bubrezni-pasulj",
  "mainVegetable/52": "povrce/jabuke",
  "mainVegetable/53": "povrce/kesteni",
  "mainVegetable/54": "povrce/suhe-sljive",
  "mainVegetable/55": "povrce/vrtlar",
  "mainVegetable/56": "povrce/crne-masline",
  "mainVegetable/57": "povrce/articoke",
  "mainVegetable/58": "povrce/crvene-paprike",
  "mainVegetable/59": "povrce/ravni-zeleni-grah",
  "mainVegetable/60": "povrce/proljece",
  "mainVegetable/61": "povrce/ratatouille",
  "mainVegetable/62": "povrce/kuskus",
  "mainVegetable/63": "povrce/tazin",
  "mainVegetable/64": "povrce/kari-sa-povrcem",
  "mainVegetable/65": "povrce/casice-od-graska",
  "mainVegetable/66": "povrce",
  "mainVegetable/67": "povrce/koralne-lece",
  "mainVegetable/68": "povrce/kvinoja",
  "mainVegetable/69": "povrce/spelta",
  "mainVegetable/70": "povrce/bulgur",
  "mainVegetable/71": "povrce/crveni-kupus",
  "mainVegetable/72": "povrce/kupusnjaca",
  "mainVegetable/73": "povrce/materina-dusica",
  "mainVegetable/74": "povrce/zitarice-i-sjemenke",
  "mainVegetable/75": "povrce/mahunarke",
  "mainVegetable/76": "povrce/slatki-krompir",
  "mainVegetable/77": "povrce/bundeve",
  "mainVegetable/78": "povrce/tjesto",
  "mainVegetable/79": "povrce/pasulj",
  "mainVegetable/80": "povrce/grah-sargarepe",
  "mainVegetable/81": "povrce/grah",
  "mainVegetable/82": "povrce/edamame",
  "mainVegetable/83": "povrce/jecam",
  "mainVegetable/84": "povrce/salata-miks",
  "mainVegetable/85": "povrce/secerni-stozac-cikorija",
  "mainVegetable/86": "povrce/jagnjeca-salata",
  "mainVegetable/87": "povrce/bebi-spanac",
  "mainVegetable/88": "povrce/bebi-zelena-batavija",
  "mainVegetable/89": "povrce/blitva",
  "mainVegetable/90": "povrce/pastrnak",
  "mainVegetable/91": "povrce/crna-venus-riza",
  "mainVegetable/92": "povrce/mjesavina-graha",
  "mainVegetable/93": "povrce/crni-pasulj",
  "mainVegetable/94": "povrce/glavica-kupusa",
  "mainVegetable/95": "povrce/bijeli-pasulj",
  "mainVegetable/96": "povrce/susene-rajcice",
  "mainVegetable/97": "povrce/mjesavina-povrca",
  "mainVegetable/98": "povrce/muskatna-tikva",
  "productRange": "asortimani",
  "productRange/4G_BIO": "asortimani",
  "productRange/4G_SRP": "asortimani",
  "productRange/CAN_A_POEL": "asortimani",
  "productRange/CAN_SEC_BI": "asortimani",
  "productRange/CAN_SEC_CO": "asortimani",
  "productRange/CAN_SEC_CU": "asortimani",
  "productRange/CAN_SEC_NA": "asortimani",
  "productRange/CAN_VAPEUR": "asortimani",
  "productRange/CAN_VEG_SA": "asortimani",
  "productRange/CAN_VEG_SR": "asortimani",
  "productRange/CLASSICVEG": "asortimani",
  "productRange/COLDVEGE": "asortimani",
  "productRange/COOKMUSH": "asortimani",
  "productRange/CRUDITES": "asortimani",
  "productRange/DE_NOS_PRO": "asortimani",
  "productRange/DOYMUSHACC": "asortimani",
  "productRange/DOYMUSHAPE": "asortimani",
  "productRange/DRYVEGE": "asortimani",
  "productRange/FROZENVEGE": "asortimani",
  "productRange/FRZ_ASTUCE": "asortimani",
  "productRange/FRZ_GRATIN": "asortimani",
  "productRange/FRZ_KELLO": "asortimani",
  "productRange/FRZ_LEG_CO": "asortimani",
  "productRange/FRZ_PUREES": "asortimani",
  "productRange/FRZ_VEG_BI": "asortimani",
  "productRange/FRZ_VEG_SR": "asortimani",
  "productRange/INDFROZVEG": "asortimani",
  "productRange/JEUNES_POU": "asortimani",
  "productRange/LAITUES": "asortimani",
  "productRange/LOOP": "asortimani",
  "productRange/LUNCH_BOWL": "asortimani",
  "productRange/MACHE_BASE": "asortimani",
  "productRange/MEL_LAITUE": "asortimani",
  "productRange/MUSHNATEMI": "asortimani",
  "productRange/MUSHNATENT": "asortimani",
  "productRange/MUSHNATEPA": "asortimani",
  "productRange/MUSHNATMIN": "asortimani",
  "productRange/MUSHROOMS": "asortimani",
  "productRange/SUNVEGE": "asortimani",
  "productRange/TRAIT_CRUD": "asortimani",
  "productRange/TRAIT_TABO": "asortimani",
  "productRange/TUS_RECETA": "asortimani",
  "productRange/WORLDVEGE": "asortimani",
  "productRange/PREPARED_VEG": "asortimani",
  "productRange/BEAN_SAUCE": "asortimani/pasulj-u-sosu",
  "productRange/BEANS": "asortimani/pasulj",
  "productRange/BIO": "asortimani/bio",
  "productRange/BOND_KIDS": "asortimani/bonduelle-djeca",
  "productRange/CAN_BIO": "asortimani",
  "productRange/CAN_SEC_PR": "asortimani",
  "productRange/CARTA_DELL": "asortimani/jelovnik-salata",
  "productRange/CAN_PETITS": "asortimani",
  "productRange/CAN_BOCAL": "asortimani",
  "productRange/CEREAL_CAN": "asortimani/zitarice-ambijent",
  "productRange/CEREAL_FRZ": "asortimani/zitarice-smrznute",
  "productRange/CEREALI": "asortimani/zitarice",
  "productRange/CEREALLEGR": "asortimani/cereallegre",
  "productRange/COCCOLE": "asortimani/coccole",
  "productRange/CORN": "asortimani/kukuruz",
  "productRange/CREATIF": "asortimani/kreativno",
  "productRange/FRANCAIS": "asortimani/100-francuski",
  "productRange/FRZ_FRY_MI": "asortimani",
  "productRange/FRZ_MELANG": "asortimani/mijesano-povrce",
  "productRange/FRZ_POELEE": "asortimani/smrznute-pripremljene-mjesavine",
  "productRange/INSALATE_D": "asortimani/poljoprivredna-salata",
  "productRange/INSALATONA": "asortimani/salata-plus",
  "productRange/LE_REGIONA": "asortimani/regionalno",
  "productRange/LEGUMIO": "asortimani/legumio",
  "productRange/MIXES_CORN": "asortimani/mijesavine-s-kukuruzom",
  "productRange/MONO_VEGE": "asortimani/jedna-vrsta-povrca-konzervirano",
  "productRange/MUSHROOMS  ": "asortimani/gljiva",
  "productRange/NATURA_IN": "asortimani/priroda-na-tanjiru",
  "productRange/OTHER_VEG": "asortimani/pripremljeno-povrce",
  "productRange/PEAS": "asortimani/grah",
  "productRange/READY_FROZ": "asortimani/spremni-smrznuti-obroci",
  "productRange/SOUPS": "asortimani/povrce-za-supe",
  "productRange/SPINACH": "asortimani/spanac",
  "productRange/STEAM_CAN": "asortimani/para-konzerva",
  "productRange/STEAM_FRZ": "asortimani/para-smrznuto",
  "productRange/STEAM_MIX": "asortimani/parena-smjesa-smrznutog-povrca",
  "productRange/STUZZICHIA": "asortimani/stuzzichiamo",
  "productRange/TOUCHE": "asortimani/obogacivac",
  "productRange/TRAIT_SAL": "asortimani/povrce-za-salatu",
  "productRange/TUS_RECETA ": "asortimani/vasi-recepti",
  "productRange/VEG_TO_FRY": "asortimani/povrce-za-przenje",
  "productRange/VEGGIE": "asortimani/povrce-riza",
  "productRange/FRZ_JUSTEA": "asortimani/jedna-vrsta-povrca-zamrznuto",
  "productRange/SALABIS": "asortimani",
  "productRange/BON_SENGAG": "asortimani",
  "productRange/CROUSTIS": "asortimani",
  "season": "sezone",
  "season/1": "sezone/ljeto",
  "season/2": "sezone/jesen",
  "season/3": "sezone/zimsko-vrijeme",
  "season/4": "sezone/proljece",
  "season/5": "sezone",
  "technologie": "tehnologija",
  "technologie/AC01": "tehnologija/cuvanje",
  "technologie/AD01": "tehnologija/zamrznuto",
  "technologie/AG01": "tehnologija/svjeze",
  "technologie/AT01": "tehnologija/ugostitelj",
  "recipeDish": "vrsta-tanjura",
  "recipeDish/ACC": "vrsta-tanjura/pratnja",
  "recipeDish/APE": "vrsta-tanjura/aperitiv",
  "recipeDish/DES": "vrsta-tanjura/dezert",
  "recipeDish/ENT": "vrsta-tanjura/ulaz",
  "recipeDish/PLAT": "vrsta-tanjura/jelo",
  "recipeDish/SAL": "vrsta-tanjura/salata",
  "recipeDish/SNA": "vrsta-tanjura/uzina-bar",
  "recipeDish/PDE": "vrsta-tanjura/dorucak",
  "recipeDish/DEJ": "vrsta-tanjura/rucak",
  "recipeDish/TRA": "vrsta-tanjura/tradicionalno",
  "recipeDish/GOU": "vrsta-tanjura/gurmanska-hrana",
  "recipeDish/ETH": "vrsta-tanjura/etnicka-pripadnost",
  "recipeDish/FCH": "vrsta-tanjura/za-djecu",
  "recipeDish/SOU": "vrsta-tanjura/supa",
  "pred-recipeTimingCook-facet": "pecenje",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "pecenje/0-15-minuta",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "pecenje/15-30-minuta",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "pecenje/30-45-minuta",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "pecenje/45-minuta",
  "pred-recipeTimingPreparation-facet": "priprema",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "priprema/0-15-minuta",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "priprema/15-30-minuta",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "priprema/30-45-minuta",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "priprema/45-minuta",
  "pred-recipeCost-Facet": "budzet",
  "pred-recipeCost-Facet/petit": "budzet/jeftino",
  "pred-recipeCost-Facet/moyen": "budzet/srednje",
  "pred-recipeCost-Facet/grand": "budzet/visoko",
  "recipeDifficulty": "priprema",
  "recipeDifficulty/1": "priprema/lako",
  "recipeDifficulty/2": "priprema/srednje",
  "recipeDifficulty/3": "priprema/pojasniti",
  "recipeDishNumber": "gosti",
  "recipeDishNumber/1": "gosti/1",
  "recipeDishNumber/2": "gosti/2",
  "recipeDishNumber/3": "gosti/3",
  "recipeDishNumber/4": "gosti/4",
  "recipeDishNumber/5": "gosti/5",
  "recipeDishNumber/6": "gosti/6",
  "recipeDishNumber/7": "gosti/7",
  "recipeDishNumber/8": "gosti/8",
  "productTheme": "proizvodi-po-temi",
  "productTheme/ACC": "proizvodi-po-temi/pratnja",
  "productTheme/BEA": "proizvodi-po-temi/pasulj",
  "productTheme/BIS": "proizvodi-po-temi/pasulj-u-sosu",
  "productTheme/BIO": "proizvodi-po-temi/bio",
  "productTheme/CAN": "proizvodi-po-temi/konzervirana-hrana",
  "productTheme/CER": "proizvodi-po-temi/zitarice",
  "productTheme/CLS": "proizvodi-po-temi/klasici",
  "productTheme/DLE": "proizvodi-po-temi/povrce",
  "productTheme/EDR": "proizvodi-po-temi/obogacivaci-obroka",
  "productTheme/ENT": "proizvodi-po-temi/predjela",
  "productTheme/FRZ": "proizvodi-po-temi/zamrznuto",
  "productTheme/FSD": "proizvodi-po-temi/za-salate",
  "productTheme/FSH": "proizvodi-po-temi/naknade",
  "productTheme/ING": "proizvodi-po-temi/sastojci-za-moje-recepte",
  "productTheme/JAR": "proizvodi-po-temi/povrce-u-tegli",
  "productTheme/LBW": "proizvodi-po-temi/posuda-za-rucak",
  "productTheme/LDF": "proizvodi-po-temi/povrce-u-rerni",
  "productTheme/LEG": "proizvodi-po-temi/mahunarke",
  "productTheme/LGO": "proizvodi-po-temi/legumio",
  "productTheme/LGR": "proizvodi-po-temi/grilovano-povrce",
  "productTheme/LGS": "proizvodi-po-temi/povrce-za-supu",
  "productTheme/MAI": "proizvodi-po-temi/onaj-ali",
  "productTheme/MUS": "proizvodi-po-temi/gljive",
  "productTheme/NEW": "proizvodi-po-temi/novi-proizvodi",
  "productTheme/PDH": "proizvodi-po-temi/suho-povrce-kuhinjska-jela",
  "productTheme/PDL": "proizvodi-po-temi/kosara-sa-povrcem",
  "productTheme/PHR": "proizvodi-po-temi/tjestenina-i-tjestenina",
  "productTheme/PLP": "proizvodi-po-temi/tanjir-glavnica",
  "productTheme/RAL": "proizvodi-po-temi/riza-povrce",
  "productTheme/RDM": "proizvodi-po-temi/kuhinja-jela",
  "productTheme/SAL": "proizvodi-po-temi/sve-za-moje-place",
  "productTheme/SDB": "proizvodi-po-temi/salata-zdjele",
  "productTheme/SNK": "proizvodi-po-temi/grickanje",
  "productTheme/SUP": "proizvodi-po-temi/supa",
  "productTheme/TEX": "proizvodi-po-temi/teks-meks",
  "productTheme/VGP": "proizvodi-po-temi/biljni-proteini",
  "recipeTheme": "recepti-po-temama",
  "recipeTheme/01": "recepti-po-temama/praznicni-recepti",
  "recipeTheme/02": "recepti-po-temama/aperitiv",
  "recipeTheme/03": "recepti-po-temama/salate-i-uzine",
  "recipeTheme/04": "recepti-po-temama/supe-i-gazpacho",
  "recipeTheme/05": "recepti-po-temama/quiche-torta-i-gratinirani-obroci",
  "recipeTheme/06": "recepti-po-temama/specijal-djeca",
  "recipeTheme/07": "recepti-po-temama/deserti",
  "recipeTheme/08": "recepti-po-temama/vegetarijanci",
  "recipeTheme/09": "recepti-po-temama/pratnja",
  "recipeTheme/10": "recepti-po-temama/dolazi-izdaleka",
  "recipeTheme/11": "recepti-po-temama/mijotes",
  "recipeTheme/12": "recepti-po-temama/salate-i-rostilj",
  "recipeTheme/13": "recepti-po-temama/grickalice-i-hrana-za-prste",
  "recipeTheme/14": "recepti-po-temama/tanjir-glavnica",
  "recipeTheme/15": "recepti-po-temama/kolaci-i-peciva",
  "recipeTheme/16": "recepti-po-temama/glavna-jela-i-supe",
  "recipeTheme/17": "recepti-po-temama/salate",
  "recipeTheme/18": "recepti-po-temama/cinije",
  "recipeTheme/19": "recepti-po-temama/supe",
  "recipeTheme/20": "recepti-po-temama/grickalice",
  "recipeTheme/21": "recepti-po-temama/umak",
  "recipeTheme/22": "recepti-po-temama/pojedinacna-jela",
  "recipeTheme/23": "recepti-po-temama/ostala-jela",
  "recipeTheme/24": "recepti-po-temama/posude-za-pecnicu",
  "recipeTheme/25": "recepti-po-temama/meksicki",
  "recipeTheme/26": "recepti-po-temama/oko-svijeta",
  "recipeTheme/27": "recepti-po-temama/dan-bez-mesa",
  "recipeTheme/28": "recepti-po-temama/niska-razina-ugljikohidrata",
  "recipeTheme/33": "recepti-po-temama/baza-od-sociva",
  "recipeTheme/34": "recepti-po-temama/baza-od-karfiola",
  "recipeTheme/35": "recepti-po-temama/baza-od-krompira",
  "recipeTheme/36": "recepti-po-temama/baza-od-mrkve",
  "recipeTheme/37": "recepti-po-temama/baza-od-spinata",
  "recipeTheme/38": "recepti-po-temama/baza-od-paprika",
  "recipeTheme/39": "recepti-po-temama/baza-od-gljiva",
  "recipeTheme/40": "recepti-po-temama/baza-od-ravnog-zelenog-graska",
  "recipeTheme/41": "recepti-po-temama/baza-od-kukuruza",
  "recipeTheme/42": "recepti-po-temama/baza-od-graska",
  "recipeTheme/43": "recepti-po-temama/baza-od-crvenog-graha",
  "recipeTheme/44": "recepti-po-temama/baza-od-flazoleta",
  "recipeTheme/45": "recepti-po-temama/baza-od-slanutka",
  "recipeTheme/46": "recepti-po-temama/baza-od-brokolija",
  "pred-particularite": "prehrambene-navike",
  "pred-particularite/Sans%20conservateur": "prehrambene-navike/bez-konzervansa",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "prehrambene-navike",
  "pred-particularite/Sans%20colorant": "prehrambene-navike/bez-boja",
  "pred-particularite/Sans%20sucre%20ajout%E9": "prehrambene-navike/bez-dodanog-secera",
  "pred-particularite/Sans%20sel%20ajout%E9": "prehrambene-navike/bez-dodane-soli",
  "pred-particularite/Sans%20additif": "prehrambene-navike/bez-aditiva",
  "pred-particularite/": "prehrambene-navike/prirodno-prisutna-so",
  "pred-particularite/Sans%20lactose": "prehrambene-navike/bez-laktoze",
  "pred-particularite/Sans%20gluten": "prehrambene-navike/bez-glutena",
  "pred-particularite/V%E9g%E9tarien": "prehrambene-navike/vege",
  "pred-particularite/V%E9g%E9talien": "prehrambene-navike/vegansko",
  "pred-particularite/Sans%20sulfite": "prehrambene-navike/bez-sumpora",
  "pred-particularite/A%20la%20vapeur": "prehrambene-navike/para",
  "pred-particularite/Sans%20condiment": "prehrambene-navike/bez-zacina",
  "cultureType": "vrstakulture",
  "cultureType/Bio": "vrstakulture/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "vrstakulture/bez-ostataka-pesticida",
  "cultureType/Sans%20OGM": "vrstakulture/bez-gmo-a",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "prehrambene-navike/vegansko",
  "pred-particularite/recipeVeggie": "prehrambene-navike/vege",
  "pred-particularite/recipeGlutenfree": "prehrambene-navike/bez-glutena",
  "pred-particularite/recipeLactosefree": "prehrambene-navike/bez-laktoze",
  "cultureOrigin": "porijeklo-kulture",
  "cultureOrigin/31": "porijeklo-kulture/azerbejdzan",
  "cultureOrigin/32": "porijeklo-kulture/argentina",
  "cultureOrigin/36": "porijeklo-kulture/australija",
  "cultureOrigin/40": "porijeklo-kulture/austrija",
  "cultureOrigin/51": "porijeklo-kulture/jermenija",
  "cultureOrigin/56": "porijeklo-kulture/belgija",
  "cultureOrigin/68": "porijeklo-kulture/bolivija",
  "cultureOrigin/70": "porijeklo-kulture/bosna-i-hercegovina",
  "cultureOrigin/76": "porijeklo-kulture/brazil",
  "cultureOrigin/97": "porijeklo-kulture/evropska-unija",
  "cultureOrigin/100": "porijeklo-kulture/bugarska",
  "cultureOrigin/104": "porijeklo-kulture/mijnmar",
  "cultureOrigin/120": "porijeklo-kulture/kamerun",
  "cultureOrigin/124": "porijeklo-kulture/kanada",
  "cultureOrigin/152": "porijeklo-kulture/cile",
  "cultureOrigin/156": "porijeklo-kulture/kina",
  "cultureOrigin/188": "porijeklo-kulture/kosta-rika",
  "cultureOrigin/191": "porijeklo-kulture/hrvatska",
  "cultureOrigin/196": "porijeklo-kulture/kipar",
  "cultureOrigin/203": "porijeklo-kulture/ceska-republika",
  "cultureOrigin/208": "porijeklo-kulture/danska",
  "cultureOrigin/231": "porijeklo-kulture/etiopija",
  "cultureOrigin/233": "porijeklo-kulture/estonija",
  "cultureOrigin/246": "porijeklo-kulture/finska",
  "cultureOrigin/250": "porijeklo-kulture/francuska",
  "cultureOrigin/258": "porijeklo-kulture/francuska-polinezija",
  "cultureOrigin/276": "porijeklo-kulture/njemacka",
  "cultureOrigin/300": "porijeklo-kulture/grcka",
  "cultureOrigin/320": "porijeklo-kulture/gvatemala",
  "cultureOrigin/344": "porijeklo-kulture/hong-kong",
  "cultureOrigin/348": "porijeklo-kulture/madjarska",
  "cultureOrigin/352": "porijeklo-kulture/island",
  "cultureOrigin/356": "porijeklo-kulture/antili",
  "cultureOrigin/360": "porijeklo-kulture/indonezija",
  "cultureOrigin/372": "porijeklo-kulture/irska",
  "cultureOrigin/376": "porijeklo-kulture/izrael",
  "cultureOrigin/380": "porijeklo-kulture/italija",
  "cultureOrigin/398": "porijeklo-kulture/kazahstan",
  "cultureOrigin/404": "porijeklo-kulture/kenija",
  "cultureOrigin/414": "porijeklo-kulture/kuvajt",
  "cultureOrigin/417": "porijeklo-kulture/kirgistan",
  "cultureOrigin/422": "porijeklo-kulture/libanon",
  "cultureOrigin/428": "porijeklo-kulture/latvija",
  "cultureOrigin/440": "porijeklo-kulture/litvanija",
  "cultureOrigin/442": "porijeklo-kulture/luksemburg",
  "cultureOrigin/450": "porijeklo-kulture/madagaskar",
  "cultureOrigin/470": "porijeklo-kulture/malta",
  "cultureOrigin/480": "porijeklo-kulture/mauricijus",
  "cultureOrigin/484": "porijeklo-kulture/meksiko",
  "cultureOrigin/498": "porijeklo-kulture/moldavija",
  "cultureOrigin/499": "porijeklo-kulture/crna-gora",
  "cultureOrigin/504": "porijeklo-kulture/maroko",
  "cultureOrigin/528": "porijeklo-kulture/holandija",
  "cultureOrigin/548": "porijeklo-kulture/vanuatu",
  "cultureOrigin/578": "porijeklo-kulture/norveska",
  "cultureOrigin/586": "porijeklo-kulture/pakistan",
  "cultureOrigin/604": "porijeklo-kulture/peru",
  "cultureOrigin/616": "porijeklo-kulture/poljska",
  "cultureOrigin/620": "porijeklo-kulture/portugal",
  "cultureOrigin/634": "porijeklo-kulture/katar",
  "cultureOrigin/642": "porijeklo-kulture/rumunija",
  "cultureOrigin/643": "porijeklo-kulture/rusija",
  "cultureOrigin/703": "porijeklo-kulture/slovacka",
  "cultureOrigin/704": "porijeklo-kulture/vijetnam",
  "cultureOrigin/705": "porijeklo-kulture/slovenija",
  "cultureOrigin/724": "porijeklo-kulture/spanija",
  "cultureOrigin/752": "porijeklo-kulture/svedska",
  "cultureOrigin/756": "porijeklo-kulture/svicarska",
  "cultureOrigin/764": "porijeklo-kulture/tajland",
  "cultureOrigin/784": "porijeklo-kulture/ujedinjeni-arapski-emirati",
  "cultureOrigin/792": "porijeklo-kulture/turska",
  "cultureOrigin/795": "porijeklo-kulture/turkmenistan",
  "cultureOrigin/804": "porijeklo-kulture/ukrajina",
  "cultureOrigin/818": "porijeklo-kulture/egipat",
  "cultureOrigin/826": "porijeklo-kulture/ujedinjeno-kraljevstvo",
  "cultureOrigin/834": "porijeklo-kulture/tanzanija",
  "cultureOrigin/840": "porijeklo-kulture/sjedinjene-americke-drzave",
  "cultureOrigin/999": "porijeklo-kulture/izvoz",
  "cultureOrigin/NON_EU": "porijeklo-kulture/van-eu",
  "cultureOrigin/UE": "porijeklo-kulture/eu",
  "cultureOrigin/XXX": "porijeklo-kulture/prazno"
};
